import React, { useContext } from "react";
import classNames from "classnames";
import { ParsedServiceData } from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/confirmation.types";
import Section from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/section/section";
import { enrollmentContext } from "@nvs/gatsby-theme-leap-core/src/components/hoc/context/enrollment/enrollment-context";
import useTranslation from "@nvs/gatsby-theme-leap-core/src/hooks/useTranslation";
import { AdherenceIcon } from "@nvs/gatsby-theme-leap-core/src/assets/images/adherence-icon";
import HeaderBottom from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/header/components/bottom";
import { ConsentIDs } from "@nvs/gatsby-theme-leap-core/src/components/hoc/constants/service.constants";
import StepsList from "@nvs/gatsby-theme-leap-core/src/components/domains/confirmation/components/header/components/expected-next-steps/steps-list";
import Panel from "../../../../../../../components/panel";
import { CommunicationIcon } from "../../../../../../../assets/images/communication-icon";
import { EmailSVG } from "../../../../../../../assets/images/email";
import { useProduct } from "@nvs/gatsby-theme-leap-core/src/hooks";
import {
  getMobileDevice,
  DEVICES,
} from "@nvs/gatsby-theme-leap-core/src/components/utilities/getMobileDevice";
import Button from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/button";
import {
  EventCategory,
  EventLabel,
  EventType,
} from "@nvs/gatsby-theme-leap-core/src/services/analytics-interfaces";
import { UserActionType } from "@nvs/gatsby-theme-leap-core/src/components/hoc/components/analytics";
import { savePhoneContact } from "../../../../../../../components/vcard";
import ConfirmationSupport from "../../../../../../../components/confirmation-support";
export interface ISummary {
  parsedData?: ParsedServiceData[];
}

export const SummaryHeader: React.FC<ISummary> = () => {
  const enrollmentCtxt = useContext(enrollmentContext);
  const { t } = useTranslation(enrollmentCtxt.performer);
  const { params } = useProduct();
  const { phoneNumber } = params;
  const isTcpa = enrollmentCtxt.input.consents.includes(ConsentIDs.tcpa);
  const steps = [
    {
      name: "communication",
      icon: <CommunicationIcon className="stroke-icon h-16" />,
      title: t("pages.icons.communication"),
      description: t("pages.confirmation.header.communication"),
    },
    {
      name: "email",
      icon: <EmailSVG className="fill-icon h-16" />,
      title: t("pages.icons.communication"),
      description: t("pages.confirmation.header.inbox"),
    },
   
  ];
  if (isTcpa) {
    steps.push({
      name: "adherence",
      icon: <AdherenceIcon className="stroke-icon h-16" />,
      title: t("pages.icons.adherence"),
      description: t("pages.confirmation.header.personalSupport"),
    });
  }
  return (
    <Section>
      <Panel>
        <Section title={t("pages.confirmation.header.title")}>
          <div
            className={classNames(
              "flex justify-center items-center flex-wrap lg:flex-nowrap gap-8 lg:gap-12 w-full divide-y-2 lg:divide-y-0 lg:divide-x-2 divide-[#FD6B0D]"
            )}
          >
          
              <div className="flex flex-col gap-8">
                <StepsList steps={steps} />
                {isTcpa && (
                  <div className="flex flex-col items-center md:hidden lg:hidden">
                    {getMobileDevice() === DEVICES.IOS ? (
                      <Button
                        onClick={() => savePhoneContact(phoneNumber)}
                        analytics={{
                          eventType: EventType.SimpleEvent,
                          eventCategory: EventCategory.Confirmation,
                          eventLabel: EventLabel?.Click,
                          eventAction: t(
                            "pages.confirmation.service.adherence.save.contact"
                          ),
                          userActionType: UserActionType.click,
                          eventArgs: {},
                        }}
                      >
                        {t("pages.confirmation.service.adherence.save.contact")}
                      </Button>
                    ) : (
                      <Button
                        analytics={{
                          eventType: EventType.SimpleEvent,
                          eventCategory: EventCategory.Confirmation,
                          eventLabel: EventLabel?.Click,
                          eventAction: t(
                            "pages.confirmation.service.adherence.save.contact"
                          ),
                          userActionType: UserActionType.click,
                          eventArgs: {},
                        }}
                      >
                        <a
                          href={"tel:" + phoneNumber}
                          className="no-underline print:text-font"
                          aria-label={`Phone  ${phoneNumber}`}
                        >
                          {t(
                            "pages.confirmation.service.adherence.save.contact"
                          )}
                        </a>
                      </Button>
                    )}
                  </div>
                )}
              </div>
          
            <div
                className={classNames(
                  "pt-8 lg:pl-12 lg:pt-0 lg:max-w-xs")}
            >
              <ConfirmationSupport  />
            </div>
          </div>
        </Section>
      </Panel>
    <HeaderBottom />
    </Section>
  );
};
